export default {
  modalTitle: 'Administrar equipo',
  modalDirectiveTitle: 'Administrar directivos',
  teamNotCreated: 'Tu equipo no está en Kimple.',
  searchPlaceholder: 'Buscar entre tu equipo',
  invite: 'Invitar vía correo electrónico',
  userName: '{name} · ({position})',
  cancel: 'Cancelar',
  confirm: 'Guardar',
  remove: 'Eliminar',
  submitMail: 'Ingresar correo electrónico',
  emailSent: 'Invitación enviada por correo electrónico',
  invitationError: 'Hubo un problema al enviar la invitación',
  pendingConfirmation: 'Esperando confirmación',
  resendInvitation: 'Volver a enviar invitación',
  inviteUser: 'Invitar',
  removeMembersQuestion: '¿Estás seguro de que quieres eliminar los miembros seleccionados de esta escuela?',
  removeMembersMessage: 'Al eliminarlas, estas personas no tendrán acceso a la plataforma Kimple de la escuela'
}

export const en = {
  modalTitle: 'Manage team',
  modalDirectiveTitle: 'Manage directors',
  teamNotCreated: 'Your team is not on Kimple.',
  searchPlaceholder: 'Search within your team',
  invite: 'Invite via email',
  userName: '{name} · ({position})',
  cancel: 'Cancel',
  confirm: 'Save',
  remove: 'Remove',
  submitMail: 'Enter email',
  emailSent: 'Invite sent via email',
  invitationError: 'Failed to send invite',
  pendingConfirmation: 'Pending confirmation',
  resendInvitation: 'Resend invite',
  inviteUser: 'Invite',
  removeMembersQuestion: 'Are you sure you want to delete selected members from this school?',
  removeMembersMessage: 'By deleting them, they won\'t have access to the school\'s Kimple platform'
}

export const ca = {
  modalTitle: 'Administra l\'equip',
  modalDirectiveTitle: 'Administra els directius',
  teamNotCreated: 'El teu equip no està a kimple.',
  searchPlaceholder: 'Cerca dins el teu equip',
  invite: 'Convida per correu electrònic',
  userName: '{name} · ({position})',
  cancel: 'Cancel·la',
  confirm: 'Desa',
  remove: 'Elimina',
  submitMail: 'Introdueix correu electrònic',
  emailSent: 'Invitació enviada per correu electrònic',
  invitationError: 'S\'ha produït un problema enviant la invitació',
  pendingConfirmation: 'Esperant la confirmació',
  resendInvitation: 'Torna a enviar la invitació',
  inviteUser: 'Convida',
  removeMembersQuestion: 'Estàs segur que vols esborrar els membres seleccionats d\'aquesta escola?',
  removeMembersMessage: 'Si les elimines, aquestes persones no tindran accés a la plataforma kimple de l\'escola'
}
